<div class="flex flex-col gap-4">
    <h1 class="titleColor text-2xl font-bold" i18n="@@adminSidebarInvoiceAdmin">Invoices</h1>
</div>

<div class="mb-4 rounded-2xl p-4">
<app-invoice-list-pharmacist-component ></app-invoice-list-pharmacist-component >
</div>




